import { EDomainName } from './EDomainName';

export { EDomainName };
